import React, { useRef, useState } from 'react';
import { decode } from 'html-entities';
import common from '../../../common/common';
import translateService from '../../../common/translateService';
import {
    handleAbuseTypeChange,
    toggleNextElementVisibility,
} from '../../../services/product/productInteraction.js';
import {
    userVoteYes,
    userVoteNo,
    reportAnswerAbuse,
} from '../../../services/questionAndAnswers/questionAndAnswersService.js';
import './ProductAnswer.scss';

const ProductAnswer = (props) => {
    const reportAbuseFormRef = useRef(null);
    const [answer, setAnswer] = useState(props.answer);
    const [abuseType, setAbuseType] = useState('');

    const handleRadioButtonClick = (e) => {
        handleAbuseTypeChange(e, reportAbuseFormRef);
        const type = e.currentTarget.value;
        setAbuseType(type);
    };

    async function handleAnswerIsUseful() {
        if (!props.isAuthenticated) {
            window.location = common.getSiteUrl(
                `${
                    window.$pathBase
                }Account/LogOn?returnUrl=${encodeURIComponent(
                    window.$pathBase + props.slug + window.location.search
                )}`
            );
            return;
        }
        if (props.isAuthenticated && !answer.userAlreadyVotedForUseful) {
            const result = await userVoteYes(
                props.questionId,
                answer.id,
                props.slug
            );

            if (result.isSuccess) {
                setAnswer((prevState) => {
                    const uselessCount = prevState.userAlreadyVotedForUseless
                        ? prevState.uselessCount - 1
                        : prevState.uselessCount;
                    const usefulCount = prevState.usefulCount + 1;

                    return {
                        ...prevState,
                        userAlreadyVotedForUseful: true,
                        userAlreadyVotedForUseless: false,
                        usefulCount: usefulCount,
                        uselessCount: uselessCount,
                    };
                });
            }
        }
    }

    async function handleAnswerIsUseless() {
        if (!props.isAuthenticated) {
            window.location = common.getSiteUrl(
                `${
                    window.$pathBase
                }Account/LogOn?returnUrl=${encodeURIComponent(
                    window.$pathBase + props.slug + window.location.search
                )}`
            );
            return;
        }
        if (props.isAuthenticated && !answer.userAlreadyVotedForUseless) {
            const result = await userVoteNo(
                props.questionId,
                answer.id,
                props.slug
            );

            if (result.isSuccess) {
                setAnswer((prevState) => {
                    const usefulCount = prevState.userAlreadyVotedForUseful
                        ? prevState.usefulCount - 1
                        : prevState.usefulCount;
                    const uselessCount = prevState.uselessCount + 1;

                    return {
                        ...prevState,
                        userAlreadyVotedForUseful: false,
                        userAlreadyVotedForUseless: true,
                        usefulCount: usefulCount,
                        uselessCount: uselessCount,
                    };
                });
            }
        }
    }

    async function handleSendReportAbuse() {
        const result = await reportAnswerAbuse(
            props.questionId,
            answer.id,
            props.slug,
            abuseType
        );

        if (result.isSuccess) {
            reportAbuseFormRef.current.classList.remove('open');
        }
    }

    return (
        <div className='prd-answer-container'>
            <div
                className='prd-answer'
                dangerouslySetInnerHTML={{
                    __html: decode(answer.answer),
                }}
            />
            <h4 className='prd-answer-author'>{answer.user.nickname}</h4>
            <div className='prd-answer-footer'>
                <div className='prd-answer-form'>
                    <p className='prd-answer-useful'>
                        {translateService.get(`productDetail.isUseful`)}{' '}
                        <span>
                            <img
                                className='prd-question-icon'
                                onClick={handleAnswerIsUseful}
                                src={
                                    answer.userAlreadyVotedForUseful
                                        ? common.contentFromCdn({
                                              path: `/Content/img/thumbup_b.svg`,
                                              keepUrlAsIs: false,
                                          })
                                        : common.contentFromCdn({
                                              path: `/Content/img/thumbup_w.svg`,
                                              keepUrlAsIs: false,
                                          })
                                }
                                alt={translateService.get(`productDetail.yes`)}
                            />{' '}
                            {answer.usefulCount}
                        </span>{' '}
                        <span>
                            <img
                                onClick={handleAnswerIsUseless}
                                className='prd-question-icon'
                                src={
                                    answer.userAlreadyVotedForUseless
                                        ? common.contentFromCdn({
                                              path: `/Content/img/thumbdown_b.svg`,
                                              keepUrlAsIs: false,
                                          })
                                        : common.contentFromCdn({
                                              path: `/Content/img/thumbdown_w.svg`,
                                              keepUrlAsIs: false,
                                          })
                                }
                                alt={translateService.get(`productDetail.no`)}
                            />{' '}
                            {answer.uselessCount}
                        </span>
                    </p>
                    {props.isAuthenticated && (
                        <div className='prd-answer-reportAbuse'>
                            <p
                                className='prd-link'
                                onClick={toggleNextElementVisibility}>
                                {translateService.get(
                                    `questions.reportAnswerAbuse`
                                )}
                            </p>
                            <div
                                className='prd-answer-reportAbuse-form'
                                ref={reportAbuseFormRef}>
                                <p>
                                    {translateService.get(
                                        `questions.answerAabuseKind`
                                    )}
                                </p>
                                <label htmlFor='vulgar'>
                                    <input
                                        onMouseUp={handleRadioButtonClick}
                                        type='radio'
                                        name='vulgar'
                                        value='Vulgar'
                                    />
                                    {translateService.get(
                                        `productDetail.vulgar`
                                    )}
                                </label>
                                <label htmlFor='spam'>
                                    <input
                                        onMouseUp={handleRadioButtonClick}
                                        type='radio'
                                        name='spam'
                                        value='Spam'
                                    />
                                    {translateService.get(`productDetail.spam`)}
                                </label>
                                <label htmlFor='useless'>
                                    <input
                                        onMouseUp={handleRadioButtonClick}
                                        type='radio'
                                        name='useless'
                                        value='Useless'
                                    />
                                    {translateService.get(
                                        `productDetail.useless`
                                    )}
                                </label>
                                <p>
                                    <a
                                        className='prd-link'
                                        onClick={handleSendReportAbuse}>
                                        {translateService.get(
                                            `productDetail.send`
                                        )}
                                    </a>
                                </p>
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProductAnswer;
